import * as React from 'react';
import { Bulk } from '../../Bulk';
import { DeletedBy } from './DeletedBy';
import { Export } from '../../Actions';
import { useDeletedWatchlistFilters } from '../../utilities';
import { Delete } from '../../Containers/ActionBar/actions/Delete';

export const ActionBar: React.FC = () => {
  const filters = useDeletedWatchlistFilters();

  return (
    <div
      className="flex justify-between items-center
   gap-4 flex-wrap"
    >
      <div className="flex space-x-4 items-center">
        <DeletedBy />
      </div>
      <div className="flex space-x-4 items-center">
        <Bulk>
          <Delete shouldDelete={false} />
        </Bulk>
        <Export filters={filters} />
      </div>
    </div>
  );
};
ActionBar.displayName = 'Shipments.DeletedContainers.ActionBar';
